// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import BorderTopOutlinedSvg from "@ant-design/icons-svg/es/asn/BorderTopOutlined";
import AntdIcon from '../components/AntdIcon';

var BorderTopOutlined = function BorderTopOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: BorderTopOutlinedSvg
  }));
};

BorderTopOutlined.displayName = 'BorderTopOutlined';
export default React.forwardRef(BorderTopOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/BorderTopOutlined.js
// module id = 669
// module chunks = 0